<!-- 问题反馈 -->
<template>
  <div class="other-feedback">
    <div class="other-feedback-con">
      <div>
        <div>
          <h1>问题反馈</h1>
          <p>在再来人辅导留学申请中，您有关于MSP的任何问题，请在此处反馈！我们非常重视您的反馈！</p>
          <Form ref="formValidate"
                :model="formValidate"
                :rules="ruleValidate">
            <FormItem label="问题类型"
                      prop="questionType">
              <Select v-model="formValidate.questionType"
                      placeholder="Select">
                <Option v-for="(item, index) in questionTypeMap"
                        :key="index"
                        :value="item.value">{{item.title}}</Option>
              </Select>
            </FormItem>
            <FormItem label="问题描述"
                      prop="descriptions">
              <div class="other-feedback-editor">
                <editor ref="analysisEditor"
                        :cache=false
                        v-model="formValidate.descriptions" />
              </div>
            </FormItem>
          </Form>
          <div class="other-feedback-btn">
            <Button class="zlr-btn-primary"
                    @click="subHandle"
                    :loading="isSub">确认提交</Button>
          </div>
        </div>
      </div>
    </div>
    <ul class="other-feedback-list"
        v-if="list.length">
      <li v-for="(item, index) in list"
          :key="index">
        <h1>问题 {{ (index+1)|fillZero }}</h1>
        <div class="other-feedback-list-type">
          问题类型：{{ item.questionType | questionTypeTitleMap}}
        </div>
        <div class="other-feedback-list-con">
          <p>问题描述</p>
          <div v-html="item.descriptions">
            {{item.descriptions}}
          </div>
        </div>
        <template v-if="item.answer">
          <div class="other-feedback-list-con">
            <p>问题回答</p>
            <div v-html="item.answer">
              {{item.answer}}
            </div>
          </div>
          <div class="other-feedback-list-evaluate">
            <span :style="{cursor: (typeof item.evaluation === 'boolean')?'inherit':'pointer'}">
              <Icon type="md-thumbs-up"
                    :color="item.evaluation?'#FFA940':'#000000'"
                    size="26"
                    @click="handleEvaluation(item, true)" />
            </span>
            <span :style="{cursor: (typeof item.evaluation === 'boolean')?'inherit':'pointer'}">
              <Icon type="md-thumbs-down"
                    :color="(typeof item.evaluation === 'boolean')? (item.evaluation?'#000000':'#FFA940'): '#000000'"
                    size="26"
                    @click="handleEvaluation(item, false)" />
            </span>
          </div>
        </template>
      </li>
    </ul>
    <zlr-empty v-else></zlr-empty>
  </div>
</template>

<script>
// api
import { getCustomerQuestionPage, saveCustomerQuestion, subCustomerQuestionEval } from '@/api/customer'
// less
import './other.less'
// components
import Editor from '_c/editor/editor'
import ZlrEmpty from '_c/empty/empty'
// constant
import { questionTypeMap } from '@/constant'
export default {
  name: 'other-feedback',
  components: {
    Editor,
    ZlrEmpty
  },
  data () {
    return {
      questionTypeMap,
      formValidate: {},
      ruleValidate: {
        questionType: [{ required: true, message: '请选择问题类型' }],
        descriptions: [{ required: true, message: '请填写描述问题' }]
      },
      isSub: false,
      list: [],
      isEval: false
    }
  },
  computed: {},
  mounted () {
    this.getPage()
  },
  methods: {
    subHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          this.isSub = true
          saveCustomerQuestion(data).then(() => {
            this.$zlr_message('反馈成功', 'success')
            this.resetData()
            this.getPage()
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    },
    getPage () {
      getCustomerQuestionPage({}).then(res => {
        this.list = res.data.list
      })
    },
    // 点赞
    handleEvaluation (item, type) {
      if (typeof item.evaluation === 'boolean' || this.isEval) return false
      let data = {
        id: item.id,
        evaluation: type
      }
      this.isEval = true
      subCustomerQuestionEval(data).then(res => {
        this.getPage()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isEval = false
      })
    },
    resetData () {
      this.$refs['analysisEditor'].resetHtml()
      this.$refs['formValidate'].resetFields()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
